import localStorageUtils from '@common/helpers/localStorage.utils';
import arrayUtils from '@common/helpers/array.utils';
import { getUrlByName } from '@common/router/router';
import sessionUtils from '@common/helpers/sessionStorage.utils';

const permissions = localStorageUtils.getItem('PERMISSION_MAP_INFO_STORAGE_KEY');

const redirectToLogin = () => {
  window.location.href = `${window.system_routes.Common.Url}/#/login`;
  return false;
};

function validator(url) {
  if (!url) return false;

  if (!permissions) {
    redirectToLogin();
    return false;
  }

  const extractedUrl = arrayUtils.extractHash(url);
  if (!extractedUrl) return true;

  const urlParts = extractedUrl.split('/');
  const urlPartsCount = urlParts.length;

  const permissionsFiltered = permissions.filter((permission) => {
    if (permission.UrlFuncionalidade) {
      const currentUrlParts = permission.UrlFuncionalidade.split('/');
      const currentUrlCount = currentUrlParts.length;

      if (urlPartsCount == currentUrlCount) {
        return currentUrlParts.join('').toLocaleLowerCase() == urlParts.join('').toLocaleLowerCase();
      }
    }
  });

  return !!permissionsFiltered.length;
}

function validatorWithIdSistema(url, idSistema = undefined) {
  if (!url) return false;

  if (!permissions) {
    redirectToLogin();
    return false;
  }

  const extractedUrl = arrayUtils.extractHash(url);
  if (!extractedUrl) return true;

  const urlParts = extractedUrl.split('/');
  const urlPartsCount = urlParts.length;

  const permissionsFiltered = permissions.filter((permission) => {
    if (permission.UrlFuncionalidade) {
      const currentUrlParts = permission.UrlFuncionalidade.split('/');
      const currentUrlCount = currentUrlParts.length;

      if (urlPartsCount == currentUrlCount) {
        for (let i = 0; i < urlPartsCount; i++) {
          if (currentUrlParts[i].indexOf(':') == 0) currentUrlParts[i] = urlParts[i];
        }

        return (
          currentUrlParts.join('').toLocaleLowerCase() == urlParts.join('').toLocaleLowerCase() &&
          permission.IdSistema == (idSistema ?? sessionUtils.getSistema())
        );
      }
    }
  });

  return !!permissionsFiltered.length;
}

export default {
  checkPermissionsByName(name) {
    const url = getUrlByName(name);
    return validator(url);
  },
  checkPermissionByUrl(url) {
    return validator(url);
  },
  getUrlPermissionByUrls(urls) {
    if (Array.isArray(urls) && urls.length > 0) {
      return urls.find(url => validator(url));
    }
    return undefined;
  },
  checkPermissionByNameAndIdSistema(name) {
    const url = getUrlByName(name);
    return validatorWithIdSistema(url);
  },
  checkPermissionByUrlAndIdSistema(url, idSistema = undefined) {
    return validatorWithIdSistema(url, idSistema);
  },
};
